import { Component, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule, AlertTriangle, Info, X } from 'lucide-angular';

import { ConfirmationModalService } from '../../../core/services/confirmation-modal.service';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [FormsModule, LucideAngularModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  private readonly confirmationModalService = inject(ConfirmationModalService);

  readonly icons = { alert: AlertTriangle, info: Info, close: X };
  readonly activeConfirmation = this.confirmationModalService.activeConfirmation;
  readonly reasonText = signal('');

  constructor() {
    effect(() => {
      if (this.activeConfirmation()) {
        this.reasonText.set('');
      }
    });
  }

  onCancel(): void {
    this.reasonText.set('');
    this.confirmationModalService.resolve(false);
  }

  onConfirm(): void {
    const reason = this.reasonText();
    this.reasonText.set('');
    this.confirmationModalService.resolve(true, reason);
  }
}
